import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Text from 'components/Text/Text';
import style from './AdditionalApplicationsField.module.scss';

export const AdditionalApplicationsField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text
				translationNameSpace="form"
				translationKey="additionalApplicationsLabel"
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.restaurantManagersList}>
				{restaurantForFullInfo?.additionalApplications ? (
					restaurantForFullInfo.additionalApplications.map((el) => {
						const applicationName = el === 'Toucan' ? '2Can' : el;

						return (
							<div key={el} className={style.item}>
								<div className={style.dot} />
								<Text translationKey={applicationName} asFragment={true} />
							</div>
						);
					})
				) : (
					<Text translationNameSpace="form" translationKey="-" />
				)}
			</div>
		</div>
	);
};
